import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { UserManagement } from '../components/Settings/UserManagement';
import { OrganizationManagement } from '../components/Settings/OrganizationManagement';
import { LandingPageEditor } from '../components/Settings/LandingPageEditor';
import { LoadingSpinner } from '../components/UI/LoadingSpinner';

export const Settings: React.FC = () => {
  const { loading, isSuperAdmin } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isSuperAdmin) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Accès refusé</h2>
          <p className="text-gray-600">
            Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Paramètres</h1>
        <p className="text-gray-600">Gérez les utilisateurs et le contenu de l'application.</p>
      </header>

      <div className="grid gap-8">
        <UserManagement />
        <OrganizationManagement />
        <LandingPageEditor />
      </div>
    </div>
  );
};